var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AiProcessorSettingsCard',{attrs:{"t":_vm.t,"fetch-settings":_vm.fetchSettings,"save-settings":_vm.saveSettings}})}
var staticRenderFns = []

export { render, staticRenderFns }